var map = {
	"./wedding-01.jpg": "ec78",
	"./wedding-02.jpg": "950b",
	"./wedding-03.jpg": "1d69",
	"./wedding-04.jpg": "25ce",
	"./wedding-05.jpg": "210e",
	"./wedding-06.jpg": "8043",
	"./wedding-07.jpg": "84fb",
	"./wedding-08.jpg": "ad3c",
	"./wedding-09.jpg": "cb52",
	"./wedding-10.jpg": "9f4e",
	"./wedding-11.jpg": "c880",
	"./wedding-12.jpg": "8276",
	"./wedding-13.jpg": "cd61",
	"./wedding-14.jpg": "ac94",
	"./wedding-15.jpg": "c391",
	"./wedding-16.jpg": "78ba",
	"./wedding-17.jpg": "1dcf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e6e0";